import { DeleteOutlined, EyeInvisibleOutlined, EyeOutlined, UploadOutlined } from '@ant-design/icons';
import { BlobProvider } from '@react-pdf/renderer';
import { Button, Col, Modal, Row, Upload, message } from 'antd';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { useFormContext } from '../../Context/DeclarationContext';
import { useTrackingContext } from '../../Context/TrackingContext';
import { getUrlFileBase64FromPSS, uploadDocumentByDocId } from '../../Services/tracking';
import { FILE_UPLOAD_GENERAL_ERROR, FILE_UPLOAD_LARGE_ERROR } from '../../utils/generals';
import SignatureDeclarations from '../Pdf/signature_declaration';
import SignatureForm from '../Signature_component';
import './index.scss';

interface IAdjunto {
  obligatorio?: boolean;
  nombre?: string;
  nombreAdjunto?: string;
  adjuntar: boolean;
  visualizar: boolean;
  componentFirma?: string;
  documentType: string;
  filename: string;
  documentId: string;
  handleDeleteDoc?: any;
  description?: any;
}
const FormAdjuntoTracking = ({
  obligatorio,
  nombre,
  nombreAdjunto,
  adjuntar,
  visualizar,
  componentFirma = '',
  documentType,
  filename = '',
  documentId = '',
  handleDeleteDoc,
  description,
}: IAdjunto) => {
  const [openModal, setOpenModal] = useState(false);
  const [urlFile, setUrlFile] = useState('');
  const [saveDocumentFDF, setSaveDocumentFDF] = useState(false);
  // const [isOpenAttachmentModal, setIsOpenAttachmentModal] = useState<boolean>(false);
  const { state, dispatch } = useTrackingContext();
  const { state: declarationState, dispatch: declarationDispatch } = useFormContext();

  const [extencion, setExtencion] = useState(nombreAdjunto?.split('.').pop() || '');
  const [uploadDisabled, setUploadDisabled] = useState<boolean>(false);
  const contentTypeMap = {
    pdf: 'application/pdf',
    png: 'image/png',
    jpg: 'image/jpg',
    jpeg: 'image/jpeg',
    jfif: 'image/jpeg',
    gif: 'image/gif',
    doc: 'application/msword',
    docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    xls: 'application/vnd.ms-excel',
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    ppt: 'application/vnd.ms-powerpoint',
    pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    txt: 'text/plain',
    csv: 'text/csv',
    xml: 'application/xml',
    json: 'application/json',
    zip: 'application/zip',
    rar: 'application/x-rar-compressed',
    '7z': 'application/x-7z-compressed',
    tar: 'application/x-tar',
    gz: 'application/gzip',
    bz2: 'application/x-bzip2',
    mp3: 'audio/mpeg',
    wav: 'audio/wav',
    ogg: 'audio/ogg',
    mp4: 'video/mp4',
    mov: 'video/quicktime',
    avi: 'video/x-msvideo',
    wmv: 'video/x-ms-wmv',
    flv: 'video/x-flv',
    mpeg: 'video/mpeg',
    webm: 'video/webm',
    webp: 'image/webp',
    svg: 'image/svg+xml',
    html: 'text/html',
    css: 'text/css',
    js: 'application/javascript',
    php: 'application/x-httpd-php',
  };
  const getUrlFetch = async (filename: string) => {
    try {
      const response = await getUrlFileBase64FromPSS(filename);
      const fdfDoc = state.documents.find((doc) => doc.documentType.code === 'FDF');
      if (response.data?.buffer) setUrlFile(response.data.buffer);
      else setUrlFile(fdfDoc?.url as string);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (nombreAdjunto) {
      getUrlFetch(nombreAdjunto || 'nombreAdjunto');
    }
  }, []);

  useEffect(() => {
    const document = state.documents.find((doc) => doc.documentType.code === documentType);
    if (document?.filename) {
      setExtencion(document?.filename.split('.').pop() as string);
      setUploadDisabled(true);
      getUrlFetch(document.filename || '');
    }
  }, [uploadDisabled, state.documents, documentType, saveDocumentFDF, extencion]);

  return (
    <>
      <Row gutter={[16, 16]} justify={'center'} className="classRowAdjunto">
        <Col span={8}>
          {documentType.includes('FDVP') ? (
            <span>{description}</span>
          ) : (
            <label>{obligatorio ? <span className="text_obligatorio">Obligatorio</span> : <span className="text_obligatorio">Opcional</span>}</label>
          )}
        </Col>
        <Col span={8}>
          <label data-render={documentType}>
            {nombre}
            {componentFirma === 'CROB' && (
              <small>
                <a href="/cuestionario_robo.pdf" download="cuestionario_robo.pdf" className="crob_link">
                  {' '}
                  Descargar cuestionario
                </a>
              </small>
            )}
            {componentFirma === 'FDF' && (
              <small>
                <BlobProvider document={<SignatureDeclarations state={declarationState} />}>
                  {({ blob, url, loading, error }) => {
                    return (
                      <a href={url as string} download="FDF.pdf" className="crob_link">
                        {' '}
                        Descargar declaración
                      </a>
                    );
                  }}
                </BlobProvider>
              </small>
            )}
          </label>
        </Col>
        <Col span={3}>
          <Upload
            disabled={uploadDisabled}
            name="avatar"
            showUploadList={false}
            // listType='picture'
            // defaultFileList={fileListFDV3.length ? [...fileListFDV3] : undefined}
            maxCount={6}
            customRequest={() => {}}
            onChange={async (info) => {
              try {
                if (info.file !== undefined) {
                  info.file.status = 'done';
                  info.file.name = filename;

                  const response = await uploadDocumentByDocId(info.file.originFileObj, documentId);
                  let document = state?.documents || [];
                  // buscar en document si existe el documento con el mismo tipo, si existe solo cambiar el nombre del archivo y la url
                  const index = document.findIndex((doc) => doc.documentType.code === documentType);
                  if (index !== -1) {
                    document[index].filename = response.data[0].filename;
                    // document[index].url = response.data[0].url;
                    document[index].status = 'done';
                    document[index].state = true;
                  }

                  dispatch({
                    type: 'UPDATE_STATE_DOCUMENT',
                    payload: [...document],
                  });
                  setUploadDisabled(true);
                }
              } catch (error) {
                if (axios.isAxiosError(error) && error.status === 413) {
                  message.error(FILE_UPLOAD_LARGE_ERROR);
                  console.log('response error: ', error.status);
                } else {
                  message.error(FILE_UPLOAD_GENERAL_ERROR);
                }
              }
            }}
          >
            <div className="upload_file_row">
              <UploadOutlined className={uploadDisabled ? 'upload_disabled' : ''} />
            </div>
          </Upload>
        </Col>
        <Col span={3}>
          {urlFile ? (
            <Button
              type="text"
              className="btn_add"
              onClick={() => {
                // urlFile is un strimg base64 necesary to convert to blob to open in new tab
                const byteCharacters = atob(urlFile);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                  byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], { type: contentTypeMap[(extencion ? extencion : 'pdf') as keyof typeof contentTypeMap] });
                const blobUrl = URL.createObjectURL(blob);

                window.open(blobUrl);
              }}
            >
              {' '}
              <EyeOutlined />{' '}
            </Button>
          ) : (
            <a className={urlFile ? 'btn_add' : 'btn_add_disbled'}>
              {' '}
              <EyeInvisibleOutlined />{' '}
            </a>
          )}
        </Col>
        <Col span={2}>
          <Button className="btn_add" type="text" disabled={urlFile ? false : true}>
            <DeleteOutlined
              className={urlFile ? 'btn_add' : 'btn_add_disbled'}
              onClick={() => {
                setUploadDisabled(false);
                const document = state?.documents || [];
                const index = document.findIndex((doc) => doc.documentType.code === documentType);
                console.log(document[index], 'index');
                handleDeleteDoc(document[index]?.id);

                if (index !== -1) {
                  if (obligatorio) {
                    document[index].filename = null;
                    // document[index].url = '';
                    document[index].status = 'done';
                  } else {
                    document[index].filename = null;
                    // document[index].url = '';
                    document[index].status = 'done';
                    document[index].state = false;
                  }
                }
                dispatch({
                  type: 'UPDATE_STATE_DOCUMENT',
                  payload: [...document],
                });
                // setReloadDocs(true)

                setUrlFile('');
                setSaveDocumentFDF(false);
                message.success('Documento eliminado correctamente');
              }}
            />
          </Button>
        </Col>
      </Row>

      <Modal
        title="Formulario de declaracion firmada"
        open={openModal}
        footer={null}
        onCancel={() => {
          setOpenModal(!openModal);
        }}
        width={'100%'}
        centered
      >
        <div
          style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <SignatureForm
            openModal={openModal}
            setOpenModal={setOpenModal}
            saveDocumentFDF={saveDocumentFDF}
            setSaveDocumentFDF={setSaveDocumentFDF}
          />
        </div>
      </Modal>

      {/* <AttachmentModal isOpen={isOpenAttachmentModal} handleClose={() => setIsOpenAttachmentModal(false)} /> */}
    </>
  );
};

export default FormAdjuntoTracking;
